export const SmallOutline = Object.freeze({
	AUDIO_TO_SCRIPT: 'so-audio-to-script',
	CHECK: 'so-check',
	CIRCLE_CHECK: 'so-circle-check',
	CLOCK: 'so-clock',
	CLOUD_TIME: 'so-cloud-time',
	CROSS: 'so-cross',
	DIGITS_24: 'so-digits-24',
	DOUBLE_CHECK: 'so-double-check',
	EARTH: 'so-earth',
	FACEBOOK: 'so-facebook',
	GIFT: 'so-gift',
	GLOBE_EXTRANET: 'so-globe-extranet',
	GROUPME: 'so-groupme',
	INSTAGRAM: 'so-instagram',
	KIK: 'so-kik',
	MAIL: 'so-mail',
	MENTION: 'so-mention',
	MESSAGE_2: 'so-message-2',
	MESSAGE: 'so-message',
	MESSENGER_META: 'so-messenger-meta',
	NOTIFICATION_OFF: 'so-notification-off',
	NOTIFICATION: 'so-notification',
	OPEN_CHANNELS: 'so-open-channels',
	PERSON: 'so-person',
	PIN: 'so-pin',
	ROBOT: 'so-robot',
	SKYPE: 'so-skype',
	SLACK: 'so-slack',
	SMALL_CROWN: 'so-small-crown',
	SMALL_HEART: 'so-small-heart',
	SMALL_PHONE_UP: 'so-small-phone-up',
	SOUND_OFF: 'so-sound-off',
	STOP: 'so-stop',
	TELEGRAM: 'so-telegram',
	TIMER_DOT: 'so-timer-dot',
	TRANSCRIPTION: 'so-transcription',
	TWILLIO: 'so-twillio',
	UNDO: 'so-undo',
	UNPIN: 'so-unpin',
	VACATION: 'so-vacation',
	VIBER: 'so-viber',
	VK: 'so-vk',
	WINDOW_SCREEN: 'so-window-screen',
} as const);